import {ExactSearchFilter} from "./search-filter";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";
import {estadosDeOpcionSolicitud} from "../../model/solicitudes/estados-solicitud-cliente";

/**
 * Filtro de Estado de los listados de diseños del cliente. Sus opciones son los textos que enseña la columna Estado
 * (la tabla está en estados-solicitud-cliente.ts) y cada una pide a la API los estados reales de cada lado:
 * `estadoCliente[solicitud][]` (los de las solicitudes sin pedido) y `estadoCliente[pedido][]` (los de su pedido), que
 * EstadoSolicitudClienteFilter de cnc-api junta con O. Un lado sin estados no se manda. Un valor que no es una opción
 * (una URL antigua) va tal cual como estado de la solicitud: si no es un estado, la API no devuelve nada.
 */
export class EstadoSolicitudClienteFilter extends ExactSearchFilter {
    dataToParams(property: InternalPropertyMap, data: any[] | any): { [p: string]: string | string[] } {
        const solicitud: string[] = [];
        const pedido: string[] = [];
        const anadir = (lista: string[], estados: string[]) =>
            estados.filter(e => !lista.includes(e)).forEach(e => lista.push(e));
        for (const valor of (Array.isArray(data) ? data : [data])) {
            const estados = estadosDeOpcionSolicitud(valor);
            if (estados.solicitud.length === 0 && estados.pedido.length === 0) {
                anadir(solicitud, [valor]);
            }
            anadir(solicitud, estados.solicitud);
            anadir(pedido, estados.pedido);
        }
        const params: { [p: string]: string[] } = {};
        if (solicitud.length > 0) {
            params[property.paramName + '[solicitud][]'] = solicitud;
        }
        if (pedido.length > 0) {
            params[property.paramName + '[pedido][]'] = pedido;
        }
        return params;
    }
}
